module.exports = __webpack_public_path__ + "img/lobby_creation.e6ea0ec6.png";